"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../");

var _default = {
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Text",
  label: "Rich Text",
  description: "The Text component allows you to add custom text to the page layout.",
  defaultAttrs: function defaultAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _.Tools.applyDefaults({
      value: {
        blocks: [{
          key: "2rols",
          text: "Your text",
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {}
        }],
        entityMap: {}
      },
      color: ""
    }, attrs);
  },
  generateContent: function generateContent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        parent = _ref.parent;

    var content = [{
      id: _.Tools.generateUUID(),
      type: "Text",
      attrs: {
        color: null
      },
      content: []
    }];
    return [{
      id: _.Tools.generateUUID(),
      type: "Row",
      attrs: {
        allowChildren: false
      },
      content: content
    }];
  }
};
exports["default"] = _default;